import * as React from "react";
import { withRouter } from 'react-router';
import * as types from "../../constants/actionTypes";
import { connect } from "react-redux";
import { logReactError } from "../../api/loggingApi";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";

class SilentErrorBoundary extends React.Component {

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    constructor(props) {
        super(props);
        //debugger;
        this.state = { hasError: false };
    }

    componentDidUpdate(prevProps) {
        const { hasError } = this.state;
        if (this.props.location.pathname !== prevProps.location.pathname) {
            if (hasError) {
                this.setState({ hasError: false });
            }
        }
    }

    componentWillUnmount() {
        const { hasError } = this.state;
        if (hasError) {
            this.setState({ hasError: false });
        }
    }

    componentDidCatch(error, info) {
        // Log to appinsights here
        this.setState({ hasError: true });
        let json = { error: error, componentStack: info };
        //logUI("MBHWeb.UI.SilentErrorBoundary.ComponentDidCatch", new Date(), Tools.getURLPath(), JSON.stringify(json));
        logUI("MBHWeb.UI.MainErrorBoundary.ComponentDidCatch", new Date(), Tools.getURLPath(), JSON.stringify(error), JSON.stringify(info));
    }

    render() {
        if (this.state.hasError) {
            // just silently fail
            return "";
        }

        return this.props.children;
    }
}


export default withRouter(SilentErrorBoundary);